import { Heading, Primary, Text } from '@cinch-labs/design-system'
import { TrackingEventTypes, useAnalytics } from '@cinch-nx/shared-analytics'

import styles from './cinchcharge-form-success.module.css'

export const CinchChargeFormSuccess: React.FC = () => {
  const { trackEvent } = useAnalytics()
  return (
    <div data-testid="cinchcharge-form-success">
      <Heading className={styles.title}>Card requested</Heading>
      <Text className={styles.bodyTop}>
        Thanks for your interest in cinchCharge!
      </Text>
      <Text className={styles.bodyBottom}>
        Our team will check whether your order is eligible. If it is, you should
        receive your card within 7 days.
      </Text>
      <Primary
        classNames={{ button: styles.button }}
        element="a"
        href="https://www.cinch.co.uk/car-care/charging-electric-cars"
        isFullWidth
        onClick={() => {
          trackEvent({
            eventName: `cinchCharge card request success - CTA click`,
            data: {
              event: {
                name: 'click',
                category: 'Card Requested',
                action: 'CTA',
                label: 'More about cinchCharge',
              },
            },
            type: TrackingEventTypes.ADOBE,
          })
        }}
      >
        More about cinchCharge
      </Primary>
    </div>
  )
}
